import React, { useState } from 'react';
import { Package, Star, Leaf, Shield, Eye, Heart, Check } from 'lucide-react';

import almendraEmp from '../../assets/images/productos/empaquetado/almendra.png';
import arandanoEmp from '../../assets/images/productos/empaquetado/arandano.png';
import canelaEmp from '../../assets/images/productos/empaquetado/canela.png';
import chileArbolEmp from '../../assets/images/productos/empaquetado/chileArbol.png';
import ciruelaPasaEmp from '../../assets/images/productos/empaquetado/ciruelaPasa.png';
import frutoSecosEmp from '../../assets/images/productos/empaquetado/frutoSecos.png';
import granolaEmp from '../../assets/images/productos/empaquetado/granola.png';
import jamaicaEmp from '../../assets/images/productos/empaquetado/jamaica.png';
import nuezEmp from '../../assets/images/productos/empaquetado/nuez.png';
import uvaPasaEmp from '../../assets/images/productos/empaquetado/uvaPasa.png';


import campofrescologo from '../../assets/images/marcas/LOGOTIPO_CAMPO FRESCO_SLOGAN_PAQUETERIA.png';



const PackagedProducts = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const closeModal = () => setSelectedProduct(null);

  const imagenesEmpaquetado = [
    {
      imagen: almendraEmp,
      titulo: "Almendras",
      descripcion: "Almendras seleccionadas y empaquetadas con tecnología MAP para máxima conservación",
      categoria: "Premium",
      detalles: ["Bolsa resellable", "Producto natural", "Mantener en lugar fresco"]
    },
    {
      imagen: arandanoEmp,
      titulo: "Arándanos",
      descripcion: "Arándanos de alta calidad con empaquetado hermético de barrera de humedad",
      categoria: "Orgánicos",
    },
    {
      imagen: canelaEmp,
      titulo: "Canela",
      descripcion: "Canela con aroma y sabor excepcional, empaquetado en atmósfera controlada",
      categoria: "Gourmet",
    },
    {
      imagen: chileArbolEmp,
      titulo: "Chile de Árbol",
      descripcion: "Chile de árbol seleccionado para dar el toque perfecto, empaquetado con micro perforaciones",
      categoria: "Shelf-Stable",
    },
    {
      imagen: ciruelaPasaEmp,
      titulo: "Ciruela Pasa",
      descripcion: "Ciruelas pasas dulces y nutritivas con empaquetado termoformado para productos delicados",
      categoria: "Premium",
    },
    {
      imagen: frutoSecosEmp,
      titulo: "Frutos Secos Mix",
      descripcion: "Mezcla selecta de frutos secos premium con empaquetado criogénico resistente",
      categoria: "Frozen",
    },
    {
      imagen: granolaEmp,
      titulo: "Granola Casera",
      descripcion: "Granola casera con ingredientes naturales, empaquetado al vacío con atmósfera modificada",
      categoria: "Ready-to-Eat",
    },
    {
      imagen: jamaicaEmp,
      titulo: "Flor de Jamaica",
      descripcion: "Flor de Jamaica deshidratada de primera calidad con empaquetado hermético garantizado",
      categoria: "Orgánicos",
    },
    {
      imagen: nuezEmp,
      titulo: "Nueces Selectas",
      descripcion: "Nueces frescas y crujientes con empaquetado en atmósfera controlada para preservar frescura",
      categoria: "Premium",
    },
    {
      imagen: uvaPasaEmp,
      titulo: "Uva Pasa Selecta",
      descripcion: "Uvas pasas dulces y jugosas con tecnología de empaquetado avanzada para máxima calidad",
      categoria: "Gourmet",
    },
  ];

  const getCategoryColor = (categoria) => {
    const colors = {
      'Orgánicos': 'bg-green-500',
      'Premium': 'bg-purple-500',
      'Gourmet': 'bg-amber-500',
      'Ready-to-Eat': 'bg-blue-500',
      'Shelf-Stable': 'bg-emerald-500',
      'Frozen': 'bg-cyan-500'
    };
    return colors[categoria] || 'bg-gray-500';
  };

  const getCategoryIcon = (categoria) => {
    const icons = {
      'Orgánicos': <Leaf className="w-4 h-4" />,
      'Premium': <Star className="w-4 h-4" />,
      'Gourmet': <Shield className="w-4 h-4" />,
      'Ready-to-Eat': <Package className="w-4 h-4" />,
      'Shelf-Stable': <Heart className="w-4 h-4" />,
      'Frozen': <Package className="w-4 h-4" />
    };
    return icons[categoria] || <Package className="w-4 h-4" />;
  };

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-6">
            <h2 className="text-4xl lg:text-5xl font-bold text-green-900 leading-tight">
              Productos
            </h2>
            <img 
              src={campofrescologo} 
              alt="Campo Fresco ICF Logo" 
              className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain drop-shadow-2xl filter brightness-110"
            />
          </div>
        </div> 

        {/* Grid de productos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {imagenesEmpaquetado.map((empaque, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-100"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="aspect-square relative overflow-hidden">
                <img 
                  src={empaque.imagen} 
                  alt={empaque.titulo}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                
                {/* Botón de vista rápida */}
                <div className={`absolute top-3 right-3 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                }`}>
                  <Eye className="w-4 h-4 text-gray-700" />
                </div>

                {/* Categoría badge */}
                <div className={`absolute top-3 left-3 px-2 py-1 rounded-lg text-white text-xs font-semibold flex items-center gap-1 transition-all duration-300 ${getCategoryColor(empaque.categoria)} ${
                  hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
                }`}>
                  {getCategoryIcon(empaque.categoria)}
                  {empaque.categoria}
                </div>
              </div>

              {/* Contenido */}
              <div className="p-4">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-bold text-lg text-gray-900 group-hover:text-green-600 transition-colors duration-300 leading-tight">
                    {empaque.titulo}
                  </h3>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-md">
                    {empaque.especificaciones}
                  </span>
                </div>
                
                <p className="text-gray-600 text-xs leading-relaxed mb-3">
                  {empaque.descripcion}
                </p>

                {/* Features técnicas */}
                <div className="flex flex-wrap gap-1 mb-3">
                  <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Certificado</span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">FDA</span>
                </div>

                {/* Información técnica */}
                <button
                  type="button"
                  className={`w-full py-2 text-center rounded-xl font-semibold text-sm transition-all duration-300 ${
                    hoveredIndex === index 
                      ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-md' 
                      : 'bg-gray-100 text-gray-700'
                  }`}
                  onClick={() => setSelectedProduct(empaque)}
                >
                  {hoveredIndex === index ? 'Ver Especificaciones' : 'Ver Información'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Modal de información */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-2 overflow-auto">
          <div className="bg-white rounded-2xl shadow-2xl w-full mx-4 sm:mx-auto max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl max-h-[85vh] overflow-y-auto">
            {/* Header */}
            <div className={`flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white`}>
              <h3 className="text-2xl font-bold">{selectedProduct.titulo}</h3>
              <button onClick={closeModal} className="text-3xl leading-none hover:opacity-80">&times;</button>
            </div>
            {/* Body */}
            <div className="p-6 flex flex-col md:flex-row gap-6">
              <div className="md:w-1/3 w-full">
                <img src={selectedProduct.imagen} alt={selectedProduct.titulo} className="w-full h-auto object-contain rounded-md shadow-inner" />
              </div>
              <div className="md:flex-grow">
                <p className="text-gray-700 text-base leading-relaxed">{selectedProduct.descripcion}</p>
                <div className="mt-4">
                  <h4 className="font-semibold text-gray-900">Categoría:</h4>
                  <span className={`inline-block mt-1 px-3 py-1 rounded-full text-sm font-medium text-white ${getCategoryColor(selectedProduct.categoria)}`}>{selectedProduct.categoria}</span>
                </div>
                <div className="mt-4">
                  <h4 className="font-semibold text-gray-900">Características:</h4>
                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Certificado</span>
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">FDA</span>
                  </div>
                </div>
                {selectedProduct.detalles && (
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-900">Detalles:</h4>
                    <ul className="list-disc list-inside text-gray-700 text-sm mt-2">
                      {selectedProduct.detalles.map((detalle, i) => (
                        <li key={i} className="flex items-center gap-2">
                          <Check className="w-4 h-4 text-green-600" />
                          {detalle}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackagedProducts;
